// GENERATED by scripts/gen-look.py from vendor-ref/nanome@868d90f: Assets/Scripts/src/Nanome.Adapter/Display/ResidueColors.cs (ResidueColors.Default)
// Do not edit by hand.

/** Residue-type colors, case-insensitive lookup; fallback magenta. */
export const RESIDUE_COLOR_DEFAULT = 0xFF00FF;
export const RESIDUE_COLORS: Readonly<Record<string, number>> = {
  ALA: 0x88E99A,
  ARG: 0x872B83,
  ASN: 0xBCE9FE,
  ASP: 0x2C457D,
  CYS: 0xDBE9A8,
  GLN: 0x115D52,
  GLU: 0x23DBE1,
  GLY: 0xBC0542,
  HIS: 0x2EE52D,
  ILE: 0xE72FC2,
  LEU: 0x5DA13B,
  LYS: 0xE689EB,
  MET: 0x1AA7EE,
  PHE: 0xC0F442,
  PRO: 0x333DCD,
  SER: 0xE9C9FA,
  THR: 0x6524FF,
  TRP: 0xF4D403,
  TYR: 0x723521,
  VAL: 0xFAB899,
  A: 0xFB7810,
  ADE: 0xFB7810,
  C: 0x8489E0,
  CYT: 0x8489E0,
  DA: 0xF3768E,
  DC: 0x6524FF,
  DG: 0xBC0542,
  DT: 0x1AA7EE,
  G: 0xFF2A0D,
  GUA: 0xFF2A0D,
  T: 0x333DCD,
  THY: 0x333DCD,
  U: 0xF4D403,
  URA: 0xF4D403,
};
